import { store, apiFuns, utils } from "sw-hic";

let api = {
  Setting: apiFuns.genStandard("setting", "/api/md", true),
  MrMain: {
    ...apiFuns.genStandard("main", "/api/emr"),
    text: (id) => apiFuns.get(`/api/emr/main/${id}/text`),
  },
  Mr: apiFuns.genStandard("mr", "/api/emr"),
  Struct: {
    query: (tmplCode, para) => apiFuns.get(`/api/emr/structureData/${tmplCode}`, para),
  },
};

const BREAK = "\r\n";

let grpStack = [];

/**
 * 整理结构化数据
 * 将循环元素整理成数组
 *
 * @param {Object} struct 结构化数据
 * @param {Object} pObj 父对象
 * @returns
 */
function orgnize(struct, pObj) {
  if (!struct) {
    return struct;
  }
  if (Array.isArray(struct)) {
    struct = struct[0];
  }
  if (!struct) {
    return struct;
  }
  if (!pObj) {
    pObj = {};
  }
  Object.keys(struct).forEach((k) => {
    if (isChn(k)) {
      let obj = {};
      let val = struct[k];
      let em = getElement(k);
      if (em) {
        if (val instanceof Object) {
          orgnize(val, obj);
        } else {
          obj = val;
        }
        if (isGrp(em)) {
          pObj[k] = [];
          pObj[k].push(obj);
          grpStack.unshift(pObj[k]); // 数组型的元素压入栈
        } else {
          pObj[k] = obj;
        }
      } else {
        let grp = grpStack.find((g) => isSimular(struct[k], g[0]));
        if (grp) {
          grp.push(copyNew(struct[k], grp[0]));
        } else {
          pObj[k] = struct[k];
        }
      }
    }
  });
  return pObj;
}

/**
 * 比较两个对象是否相似
 * 只比较属性数量是否一样
 *
 * @param {Object} src
 * @param {Object} tgt
 * @returns 是或否
 */
function isSimular(src, tgt) {
  if (!(src instanceof Object) || !(tgt instanceof Object)) {
    return false;
  }

  return Object.keys(src).length == Object.keys(tgt).length;
}

/**
 * 以目标对象的数据结构结构做模板，将原对象属性赋值到新对象
 * @param {Object} src 源对象
 * @param {Object} tgt 目标对象
 * @returns 与目标对象结构相同新对象
 */
function copyNew(src, tgt) {
  if (!(tgt instanceof Object) || Array.isArray(tgt)) {
    return src;
  }
  let rst = {};
  let i = 0;
  Object.keys(tgt).forEach((k) => {
    let val = src[Object.keys(src)[i++]];
    if (val instanceof Object) {
      rst[k] = copyNew(val, tgt[k]);
    } else {
      rst[k] = val;
    }
  });
  return rst;
}

function fmtRNTxt(txt) {
  txt = txt ?? "";
  txt = txt.replace(/回车/g, BREAK);
  txt = txt.replace(/换行/g, BREAK);
  txt = txt.replace(/空格/g, " ");
  return txt;
}

/**
 * 根据元素配置结构化数据格式化成字符串
 *
 * @param {Object} struct
 * @returns 字符串
 */
function fmt(struct) {
  let rst = "";
  if (struct instanceof Array) {
    struct.forEach((s) => {
      rst += fmt(s);
    });
  } else if (struct instanceof Object) {
    Object.keys(struct).forEach((k) => {
      if (isChn(k)) {
        let val = struct[k];
        let em = getElement(k);
        if (em) {
          if (em.ifExport) {
            rst += fmtRNTxt(em.exportStartTxt);
            if (em.ifExportLabel) {
              rst += em.label || em.name;
              rst += fmtRNTxt(em.afterLabelTxt);
            }
            if (val) {
              if (val instanceof Object) {
                rst += fmt(val);
              } else {
                rst += val.toString();
              }
            }
            rst += fmtRNTxt(em.exportEndTxt);
          }
        } else {
          rst += k + "：";
          if (val) {
            if (val instanceof Object) {
              rst += fmt(val);
            } else {
              rst += val.toString();
            }
          }
          rst += "；";
        }
      }
    });
  }

  return rst;
}

/**
 * 字符串是否是中文字符打头
 *
 * @param {String} txt 字符串
 * @returns 是或否
 */
function isChn(txt) {
  let reg = new RegExp("[\\u4E00-\\u9FFF]+", "g");
  return reg.test(txt.substring(0, 1));
}

/**
 * 根据名称查找对应的元素类型
 *
 * @param {String} name 元素名称
 * @returns 元素类型对象
 */
function getElement(name) {
  name = name.split("-")[0];
  return store.getters.dict.MrElement.find((m) => m.name == name);
}

/**
 * 是否是复合类型的元素
 *
 * @param {Object} em
 * @returns 是或否
 */
function isGrp(em) {
  return em.type == "数据组" || em.type == "病历段" || em.type == "表格";
}

/**
 * 输出病历文本到HIS
 *
 * @param {病历ID} mainId
 * @param {子系统实体} sys
 * @returns
 */
async function exportStructDataToHis(mainId, sys) {
  utils.log("输出病历文本到HIS");
  if (!mainId || !sys) {
    utils.log("参数错误！");
    return;
  }

  let res = await api.Setting.query({ sysCode: sys.code, code: "apiToHis" });

  if (!res.items || !res.items.length || !res.items[0].value) {
    utils.log("没找到病历输出HIS接口配置！");
    return;
  }

  let exportApi;
  try {
    exportApi = JSON.parse(res.items[0].value);
  } catch (error) {
    console.log("病历输出HIS接口配置错误!");
    return;
  }
  utils.log(exportApi);

  let main = await api.MrMain.get(mainId);

  // let mrs = (await api.Mr.query({ mainId: mainId })).items;
  // if (!mrs.length) {
  //   console.log("当前病历没有文书!");
  //   return;
  // }

  // 病历字符串
  // let tmplCodes = [];
  // let content = "";
  // for (let i = 0; i < mrs.length; i++) {
  //   const item = mrs[i];
  //   if (tmplCodes.findIndex((c) => c == item.tmplCode) == -1) {
  //     tmplCodes.push(item.tmplCode);
  //     let sDatas = await api.Struct.query(item.tmplCode, { mainId: item.mainId, dbVer: 1 });
  //     if (!sDatas || !sDatas.length) {
  //       res = await api.Struct.query(item.tmplCode, { mrId: item.mainId });
  //     }
  //     // content += format(res);
  //     if (sDatas && sDatas.length) {
  //       sDatas.forEach((sd) => {
  //         // content += BREAK + "【" + utils.Dict.text(item.tmplCode, "MrTemplate") + "】" + ` ${sd.createUserName} ${sd.createTime}` + BREAK;
  //         // content += BREAK + `${sd.createUserName} ${sd.createTime}` + BREAK;
  //         content += (format(sd) || sd.allText) + BREAK;
  //       });
  //     }
  //   }
  // }

  // for (let i = 0; i < 4; i++) {
  //   content = content.replace(/\r\n\r\n/g, BREAK);
  // }

  let content = await api.MrMain.text(mainId);

  utils.log(content);

  // 准备调用参数
  let para = {};
  Object.keys(exportApi.mapping).forEach((k) => {
    if (k == "content") {
      para[exportApi.mapping[k]] = content;
    } else if (k == "userName") {
      para[exportApi.mapping[k]] = main.submitUserName;
    } else if (k == "now") {
      para[exportApi.mapping[k]] = utils.Fmt.datetime(new Date());
    } else if (k == "deptName") {
      para[exportApi.mapping[k]] = utils.Dict.text(main.deptCode, "Dept");
    } else {
      para[exportApi.mapping[k]] = main[k];
    }
  });

  utils.log(para);

  try {
    let method = exportApi.method.toLowerCase();
    let url = exportApi.path;
    await apiFuns[method](url, para);
  } catch (error) {
    console.log(error);
  }
}

/**
 * 根据模板格式化字符串对结构化数据进行格式化
 * @param {结构化数据} struct
 * @param {格式化字符串} fmtStr
 * @returns
 */
function fmtByTmpl(struct, fmtStr) {
  let rst = fmtStr;
  Object.keys(struct).forEach((k) => {
    if (rst.indexOf(`{${k}}`) >= 0) {
      // 简单元素
      rst = rst.replace(`{${k}}`, struct[k]);
    } else if (rst.indexOf(`[${k}:`) >= 0) {
      // 复合元素
      let reg = new RegExp(`\\\[${k}:([\\s\\S]*?)\\\]`);
      let test = rst.match(reg);
      if (test && test[0]) {
        let origin = test[0];
        let docFmt = test[1];
        let items = struct[k];
        if (!Array.isArray(items)) {
          items = [items];
        }
        let str = "";
        items.forEach((i) => {
          str += fmtByTmpl(i, docFmt);
        });
        rst = rst.replace(origin, str);
      } else {
        console.log("格式化时发生错误，无法找到" + reg.toString() + "匹配项");
      }
    } else {
      utils.log("数据未找到匹配元素");
      utils.log(k + ":" + struct[k]);
    }
  });

  return rst;
}

/**
 * 格式化结构化数据
 *
 * @param {结构化数据} struct
 * @param {模板编码} tmplCode
 * @returns
 */
function format(struct, tmplCode) {
  if (!struct) {
    return "";
  }
  if (!Array.isArray(struct)) {
    struct = [struct];
  }
  let rst = BREAK;

  // 先判断是否有模板格式化字符串
  if (tmplCode) {
    let tmpl = store.getters.dict.MrTemplate.find((m) => m.code == tmplCode);
    if (tmpl?.docFormat) {
      let docFmt = tmpl.docFormat;

      struct.forEach((s) => {
        if (s.dbVer) {
          rst += BREAK + fmtByTmpl(s, docFmt);
        } else {
          rst += BREAK + fmtByTmpl(orgnize(s), docFmt);
        }
      });

      rst = rst.replace(/[^;\r\n]*?：{.*?};?/g, "");
      for (let i = 0; i < 4; i++) {
        rst = rst.replace(/\r\n\r\n/g, BREAK);
      }
      return rst;
    }
  }

  // 没有的话根据元素配置格式化
  struct.forEach((s) => {
    grpStack = [];
    if (s.dbVer) {
      rst += BREAK + fmt(s);
    } else {
      rst += BREAK + fmt(orgnize(s));
    }
  });
  return rst;
  // return orgnize(struct)
  // return struct
}

export default {
  orgnize,
  format,
  exportStructDataToHis,
};

export { orgnize, format, exportStructDataToHis };
